import { useTranslation } from 'react-i18next';
import styles from '../detail.module.scss';

interface StatementAccountContext {
    meterNumber: string;
    period: StatementOfAccountReportPeriodDto;
}
interface StatementOfAccountReportPeriodDto {
    from: string;
    to: string;
}
interface StatementOfAccountDetailProps {
    context: StatementAccountContext;
}


const formatDate = (value?: string): string => {
    if (!value) return '';
    const date = new Date(value);
    return isNaN(date.getTime())
        ? value
        : date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const StatementOfAccountDetail: React.FC<StatementOfAccountDetailProps> = ({ context }) => {
   const { t } = useTranslation();
   const message = t('notifications.web.statementSentMessage', {
       meterNumber: context.meterNumber,
       from: formatDate(context.period?.from),
       to: formatDate(context.period?.to),
   });

   return  <div className={styles.container}>
            <div className={styles.messageBlock}>
                {message && (
                     <span className={styles.messageBody}> {message}</span>  
                )}
            </div>

            
        </div>
};

export default StatementOfAccountDetail;
